import { withLoginEnforced } from '@/shared/auth/oidc';
import { useGetCurrentUser, useIsAdmin } from '@/shared/auth/useDirectusUser';
import { Alert, Box } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  children: React.ReactNode;
};

const AdminGate = ({ children }: Props) => {
  const { t } = useTranslate();
  const { status } = useGetCurrentUser();
  const isAdmin = useIsAdmin();

  if (status === 'loading') {
    return null;
  }

  if (!isAdmin) {
    return (
      <Box maw={400} mx="auto" mt="xl">
        <Alert
          variant="light"
          color="yellow"
          title={t('permission.notfound.title')}
          icon={<IconAlertTriangle />}
        >
          {t('permission.notfound.content')}
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default withLoginEnforced(AdminGate);
